<template>
  <div class="product-container">
    <a :href="product.link" target="_blank">
      <img :src="require(`@/assets/products/${product.id}.png`)">
      <div class="right">
        <h5>{{product.title}}</h5>
        <p>
          {{product.descr}}
        </p>
        <footer>{{product.displayLink}}
          <span>→</span>
        </footer>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: ["product"],
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "~@/styles/common.scss";
.product-container {
  display: block;
  a {
    display: block;
    width: 100%;
    float: left;
    margin-top: 50px;
    position: relative;
    color: #fff;
    img {
      width: 308px;
      float: left;
    }
    .right {
      width: 100%;
      padding-left: 340px;
      box-sizing: border-box;
      height: 190px;
      position: relative;
      h5 {
        float: left;
        font-size: 24px;
        letter-spacing: 1.2px;
        margin-top: 3px;
        height: 34px;
        position: relative;
        @include link-effect();
      }
      p {
        float: left;
        width: 100%;
        font-size: 15px;
        line-height: 25px;
        letter-spacing: 0.75px;
        margin-top: 20px;
      }
      footer {
        position: absolute;
        bottom: 5px;
        left: 340px;
        font-size: 15px;
        display: inline-block;
        letter-spacing: 0.75px;
        span {
          display: inline-block;
        }
      }
    }
  }
  &:hover {
    a .right h5 {
      &:after {
        @include link-effect-hover();
      }
    }
    footer span {
      animation: arrowBounce 2s infinite;
    }
  }
}

@media (max-width: 600px) {
  .product-container {
    a {
      img {
        display: none;
      }
      .right {
        padding-left: 0px;
        h5{
          line-height: 30px;
          height: auto;
          &::after{
            display: none;
          }
        }
        footer {
          left: 0px;
        }
      }
    }
  }
}

@keyframes arrowBounce {
  0%,
  30%,
  50%,
  80%,
  100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(10px);
  }
  60% {
    transform: translateX(5px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue